/* ORALYA — Source v2 · interactions */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ----- En-tête qui se densifie au défilement -----
  var header = document.querySelector('.header');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 24); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  // ----- Apparition (avec décalage automatique dans les grilles) -----
  document.querySelectorAll('.grid, .ritual__grid, .stats, .trust__in, .inbox__list').forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (el, i) {
      if (el.classList.contains('reveal')) el.style.setProperty('--d', (i * 90) + 'ms');
    });
  });
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  document.querySelectorAll('.reveal').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });

  // ----- Manifeste : les mots s'allument au défilement -----
  document.querySelectorAll('[data-manifesto]').forEach(function (el) {
    var words = el.querySelectorAll('.w');
    if (!words.length) return;
    function update() {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    }
    window.addEventListener('scroll', update, { passive: true }); update();
  });

  // ----- Compteurs animés -----
  function animateNumber(el) {
    var raw = el.dataset.count; if (!raw) return;
    var target = parseFloat(raw.replace(',', '.')); if (isNaN(target)) return;
    var decimals = (raw.split(/[,.]/)[1] || '').length;
    var suffix = el.dataset.suffix || '';
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = (target * k).toFixed(decimals).replace('.', ',') + suffix;
      if (k < 1) requestAnimationFrame(step);
    }
    if (reduce) { el.textContent = raw + suffix; return; }
    requestAnimationFrame(step);
  }
  var cio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { animateNumber(e.target); cio.unobserve(e.target); } });
  }, { threshold: 0.4 }) : null;
  document.querySelectorAll('[data-count]').forEach(function (el) { if (cio) cio.observe(el); else animateNumber(el); });

  // The form's native selector is the only submitted variant field.
  function initBuy(root) {
    if (root.dataset.buyReady) return;
    root.dataset.buyReady = 'true';
    var form = root.querySelector('form');
    var variantInput = form && form.querySelector('[name="id"][data-variant-input]');
    if (!variantInput) return;
    var stage = root.querySelector('[data-stage]');
    var images = stage ? Array.prototype.slice.call(stage.querySelectorAll('img')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-swatch]'));
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var nameOut = root.querySelector('[data-variant-name]');
    var stock = root.querySelector('[data-stock]');
    var quantity = form.querySelector('[data-quantity]');
    var submit = form.querySelector('[data-submit]');
    var sticky = document.getElementById(root.dataset.stickyId);

    function showImage(id) {
      if (!images.length) return;
      var target = images.find(function (img) { return String(img.dataset.imageId) === String(id); }) || images[0];
      images.forEach(function (img) {
        var active = img === target;
        img.classList.toggle('is-active', active);
        img.setAttribute('aria-hidden', String(!active));
      });
      thumbs.forEach(function (thumb) {
        var active = String(thumb.dataset.imageId) === String(target.dataset.imageId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }

    function selectVariant(updateUrl) {
      var option = variantInput.options[variantInput.selectedIndex];
      if (!option) {
        if (submit) submit.disabled = true;
        return;
      }
      var available = option.dataset.available === 'true';
      swatches.forEach(function (swatch) {
        var active = swatch.dataset.variantId === option.value;
        swatch.classList.toggle('is-active', active);
        swatch.setAttribute('aria-pressed', String(active));
        if (active && stage && swatch.dataset.tint) stage.style.background = swatch.dataset.tint;
      });
      if (priceNow) priceNow.textContent = option.dataset.price || '';
      if (priceWas) {
        priceWas.textContent = option.dataset.compare || '';
        priceWas.hidden = !option.dataset.compare;
      }
      if (nameOut) nameOut.textContent = option.dataset.name || '';
      if (stock) stock.textContent = available ? 'Disponible' : 'Ce coloris est actuellement indisponible.';
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.label : 'Indisponible';
      }
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        if (!quantity.checkValidity()) quantity.value = quantity.min;
      }
      showImage(option.dataset.imageId);
      if (sticky) {
        var stickyPrice = sticky.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      }
      if (updateUrl && document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(thumb.dataset.imageId); });
    });
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        variantInput.value = swatch.dataset.variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    variantInput.addEventListener('change', function () { selectVariant(true); });
    form.addEventListener('submit', function (event) {
      var option = variantInput.options[variantInput.selectedIndex];
      if (!option || option.dataset.available !== 'true') {
        event.preventDefault();
        variantInput.focus();
        return;
      }
    });
    selectVariant(false);

    if (sticky) {
      function updateSticky() {
        if (!root.isConnected) {
          window.removeEventListener('scroll', updateSticky);
          window.removeEventListener('resize', updateSticky);
          return;
        }
        var rect = root.getBoundingClientRect();
        var visible = window.matchMedia('(max-width: 760px)').matches && window.scrollY > 300 && (rect.bottom <= 0 || rect.top >= window.innerHeight);
        sticky.classList.toggle('is-on', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.inert = !visible;
      }
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }
  }
  document.querySelectorAll('[data-buy]').forEach(initBuy);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-buy]').forEach(initBuy);
    event.target.querySelectorAll('.reveal').forEach(function (element) { element.classList.add('is-in'); });
  });

  // ----- Coloris immersifs : fond de section + photo -----
  document.querySelectorAll('[data-colorways]').forEach(function (root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-cw-image]'));
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-cw]'));
    var productLink = root.querySelector('[data-cw-product-link]');
    function pick(b) {
      btns.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', String(x === b)); });
      imgs.forEach(function (im) { im.classList.toggle('is-active', im.dataset.cwImage === b.dataset.cw); });
      if (productLink && b.dataset.productUrl) productLink.href = b.dataset.productUrl;
      if (b.dataset.bg) root.style.background = b.dataset.bg;
    }
    btns.forEach(function (b) { b.addEventListener('mouseenter', function () { pick(b); }); b.addEventListener('click', function () { pick(b); }); b.addEventListener('focus', function () { pick(b); }); });
    if (btns.length) pick(btns[0]);
    // rotation douce tant que personne n'interagit
    if (!reduce && btns.length > 1) {
      var i = 0, timer = setInterval(function () { i = (i + 1) % btns.length; pick(btns[i]); }, 3200);
      ['mouseenter', 'pointerdown', 'focusin'].forEach(function (eventName) {
        root.addEventListener(eventName, function () { clearInterval(timer); }, { once: true });
      });
    }
  });

})();
